import { render, staticRenderFns } from "./ServiceBox.vue?vue&type=template&id=373e26e6&scoped=true&"
import script from "./ServiceBox.vue?vue&type=script&lang=js&"
export * from "./ServiceBox.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBox.vue?vue&type=style&index=0&id=373e26e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373e26e6",
  null
  
)

export default component.exports